import { render, staticRenderFns } from "./ChairMessage.vue?vue&type=template&id=302ff5b8&scoped=true&"
import script from "./ChairMessage.vue?vue&type=script&lang=js&"
export * from "./ChairMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChairMessage.vue?vue&type=style&index=0&id=302ff5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302ff5b8",
  null
  
)

export default component.exports